import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TreeViewList from './Components/TreeViewList';
import TreeViewSelected from './Components/TreeViewSelected';
import './TreeView.scss';

function TreeView({
  taxonomies,
  selectedTaxonomies,
  selectedListExpanded,
  selectedCustomItems,
  toggleSelectedList,
  toggleTaxonomy,
  loadTaxonomy,
  selectTaxonomy,
  removeTaxonomy,
  onReset,
  init,
  showCountIndicator,
}) {
  useEffect(() => {
    init();

    return () => {
      onReset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onToggleViewList = (taxonomy) => {
    if (!taxonomy.isFolder) {
      return;
    }
    if (taxonomy.children.length) {
      toggleTaxonomy(taxonomy);
      return;
    }
    loadTaxonomy(taxonomy);
  };

  return (
    <div className="treeView">
      {!selectedListExpanded && taxonomies.length ? (
        <TreeViewList
          taxonomies={taxonomies}
          onToggle={onToggleViewList}
          onSelect={selectTaxonomy}
          showCountIndicator={showCountIndicator}
        />
      ) : null}

      {selectedTaxonomies.length || selectedCustomItems.length ? (
        <TreeViewSelected
          selectedListExpanded={selectedListExpanded}
          selectedTaxonomies={selectedTaxonomies}
          onToggle={toggleSelectedList}
          onRemove={removeTaxonomy}
          selectedCustomItems={selectedCustomItems}
        />
      ) : null}
    </div>
  );
}

TreeView.propTypes = {
  showCountIndicator: PropTypes.bool,
  taxonomies: PropTypes.array,
  selectedTaxonomies: PropTypes.array,
  selectedCustomItems: PropTypes.array,
  selectedListExpanded: PropTypes.bool,
  toggleSelectedList: PropTypes.func.isRequired,
  toggleTaxonomy: PropTypes.func.isRequired,
  loadTaxonomy: PropTypes.func.isRequired,
  selectTaxonomy: PropTypes.func.isRequired,
  removeTaxonomy: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
};

export default TreeView;
